import React, { Component } from 'react';
import * as QueryString from 'query-string';
import { Row, Col } from 'react-bootstrap';

import Uuid from '../../../support/Uuid';
import { Auth, Http } from '../../../support';
import LoadingButton from '../../../facturotopia/LoadingButton';
import PageHeader from '../../../support/page-header/PageHeader';
import ResponseError from '../../../shared/responses/ResponseError';
import ResponseResult from '../../../shared/responses/ResponseResult';
import TotalGlobalSummary from '../../../app/comprobantes/create/components/TotalGlobalSummary';
import ReceptorFiscalInfoForm from '../../../app/receptores/upsert/components/ReceptorFiscalInfoForm';
import TimbradoTicketRequestSearch from '../../autofacturacion/components/TimbradoTicketRequestSearch';
import ConceptosNotEditableList from '../../../app/comprobantes/create/components/conceptos/ConceptosNotEditableList';

class AutofacturacionTicketTimbradoRequest extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      downloaded: false,
    };
  }

  get rules() {
    return {
      codigo: ['required', 'max:255'],
    };
  }

  get inputs() {
    return {
      key: {
        name: 'codigo',
        label: 'Código',
      },
    };
  }

  onReceptorFormDataChange = (event) => {
    const {
      data,
      data: { input = {} },
    } = this.state;

    const state = {
      data: {
        ...data,
        input: {
          ...input,
          Receptor: {
            ...event.data,
          },
        },
      },
      isValid: event.isValid,
    };

    this.setState({
      ...state,
    });
  };

  handleOnSearchSuccess = (data) => {
    const profile = Auth.getUser();

    this.setState({
      data: {
        ...this.state.data,
        input: {
          ...data,
          Receptor: {
            id: profile.id,
            rfc: profile.rfc,
            razon_social: profile.nombre || profile.razon_social,
            email: profile.email,
            uso_cfdi: profile.uso_cfdi || 'G03',
          },
        },
      },
    });
  };

  submit = async () => {
    const {
      data: { input },
    } = this.state;

    this.setState({
      busy: true,
    });

    try {
      const params = QueryString.parse(this.props.location.search);

      const headers = {
        'X-Tenancy': params.tenancy,
      };

      const body = {
        ...input,
        Receptor: {
          Id: input.Receptor.id,
          CP: input.Receptor.cp,
          Rfc: input.Receptor.rfc,
          Email: input.Receptor.email,
          Regimen: input.Receptor.regimen,
          UsoCFDI: input.Receptor.uso_cfdi,
          Nombre: input.Receptor.razon_social,
        },
      };

      const response = await Http.post(`api/autofacturacion/facturas`, body, { headers });

      this.setState({
        busy: false,
        result: response,
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false,
      });
    }
  };

  handleOnAction = () => {
    const { result } = this.state;

    window.location = result.data.link;

    this.setState({
      downloaded: true,
    });
  };

  handleResetError = () => {
    this.setState({
      error: undefined,
    });
  };

  handleOnDone = () => {
    this.setState({
      data: {},
      result: undefined,
      error: undefined,
      downloaded: false,
    });

    this.props.history.replace('/ext/receptores/autofacturacion/tickets');
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleResetError}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result: _result, downloaded } = this.state;

    let result = {
      ..._result,
      message: _result.message + ' Si quieres descargar tu factura haz click en "Descargar"',
    };

    if (downloaded) {
      return (
        <div className="result-container">
          <ResponseResult
            title="Factura emitida."
            result={result}
            btnText="Continuar"
            onAction={this.handleOnDone}
          />
        </div>
      );
    }

    return (
      <div className="result-container">
        <ResponseResult
          title="Factura emitida."
          result={result}
          btnText="Descargar mi factura"
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const {
      busy,
      data: { input },
      isValid,
      error,
      result,
    } = this.state;

    if (!!input && !!input.Conceptos && !!input.Conceptos.Concepto) {
      input.Conceptos.Concepto = input.Conceptos.Concepto.map((item) => {
        if (!item.id) {
          item = {
            ...item,
            id: Uuid.v4(),
          };
        }

        return item;
      });
    }

    return (
      <>
        <PageHeader
          to="/ext/receptores/autofacturacion/tickets"
          text="Tickets"
        />

        <Row>
          <Col
            md={6}
            sm={true}
          >
            <div className="pb-3">
              <strong className="text-info text-uppercase">Facturas On-Demand</strong>
            </div>
          </Col>
        </Row>

        {!!result && this.renderResult()}

        {!!error && this.renderError()}

        {!input && (
          <Row>
            <Col
              md={6}
              sm={true}
            >
              <div className="pb-3">
                <TimbradoTicketRequestSearch onSearchSuccess={this.handleOnSearchSuccess} />
              </div>
            </Col>
            <Col
              md={6}
              sm={true}
              className="py-3"
            >
              Hola, para solicitar tu factura sigue los siguientes pasos:
              <br />
              <br />
              1. Introduce el código proporcionado por el establecimiento.
            </Col>
          </Row>
        )}

        {!!input && (
          <>
            <Row>
              <Col
                md={6}
                sm={true}
                className="py-3"
              >
                <div className="pb-3">
                  <ReceptorFiscalInfoForm
                    data={input.Receptor || {}}
                    autoFocus={true}
                    datos_fiscales_requeridos={true}
                    onFormDataChange={this.onReceptorFormDataChange}
                  />
                </div>
              </Col>

              <Col
                md={6}
                sm={true}
                className="py-3"
              >
                Hola, para solicitar tu factura sigue los siguientes pasos:
                <br />
                <br />
                <s>1. Introduce el código proporcionado por el establecimiento.</s>
                <br />
                {!result && <span>2. Completa tu información fiscal.</span>}
                {!!result && <s>2. Completa tu información fiscal.</s>}
                <br />
                {!!result && <span>3. Guarda tu factura, adicionalmente la recibirás por email.</span>}
              </Col>
            </Row>

            <Row>
              <Col
                sm={12}
                xs={true}
                className="pb-5"
              >
                <div className="pb-3">
                  <strong className="text-info">Conceptos</strong>
                </div>

                <ConceptosNotEditableList
                  data={!!input && !!input.Conceptos && !!input.Conceptos.Concepto ? input.Conceptos.Concepto : []}
                />

                <TotalGlobalSummary data={input} />

                <LoadingButton
                  type="button"
                  disabled={!isValid}
                  loading={busy || false || !!result}
                  onClick={this.submit}
                >
                  {busy ? 'Procesando...' : 'Facturar'}
                </LoadingButton>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }
}

export default AutofacturacionTicketTimbradoRequest;
